/**
 * Mode Toggle Component
 * [ 📋 สั่งอาหาร | 🪑 จองโต๊ะ ]
 * Placed before "Select Meal Period" section.
 */

import { getCurrentLanguage } from '../../../i18n';

export type RestaurantMode = 'order' | 'reserve';

const LABELS: Record<string, { order: string; reserve: string }> = {
  th: { order: '📋 สั่งอาหาร', reserve: '🪑 จองโต๊ะ' },
  en: { order: '📋 Order Food', reserve: '🪑 Reserve Table' },
  zh: { order: '📋 点餐', reserve: '🪑 预订餐桌' },
  ru: { order: '📋 Заказать', reserve: '🪑 Забронировать' },
  ja: { order: '📋 注文する', reserve: '🪑 予約する' },
  ko: { order: '📋 주문하기', reserve: '🪑 예약하기' },
};

export function renderModeToggle(active: RestaurantMode): string {
  const lang = getCurrentLanguage();
  const labels = LABELS[lang] || LABELS.en;

  const activeStyle = 'background:#00B900;color:#fff;font-weight:700;';
  const inactiveStyle = 'background:#fff;color:#333;font-weight:500;';

  return `
    <div id="rest-mode-toggle" style="
      display:flex;
      border:1.5px solid #00B900;
      border-radius:10px;
      overflow:hidden;
      margin-bottom:16px;
    ">
      <button
        id="rest-mode-order"
        onclick="window.setRestaurantMode?.('order')"
        aria-pressed="${active === 'order'}"
        style="flex:1;padding:11px 8px;border:none;cursor:pointer;font-size:14px;transition:background 0.18s,color 0.18s;${active === 'order' ? activeStyle : inactiveStyle}"
      >${labels.order}</button>
      <div style="width:1.5px;background:#00B900;"></div>
      <button
        id="rest-mode-reserve"
        onclick="window.setRestaurantMode?.('reserve')"
        aria-pressed="${active === 'reserve'}"
        style="flex:1;padding:11px 8px;border:none;cursor:pointer;font-size:14px;transition:background 0.18s,color 0.18s;${active === 'reserve' ? activeStyle : inactiveStyle}"
      >${labels.reserve}</button>
    </div>
  `;
}
